/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { createLink, updateLink } from '../../services/links'
import { Button } from '../Button'
import { DatePickerComp } from '../DateRangePicker/DateRangePicker.tsx'
import { TimeZoneSelect } from '../TimezoneSelect/TextHeader.tsx'

interface IValue {
  value: { title: string; link: string }
  addLink: Date | string
  hideLink: Date | string
  timezone: string | string
}

export const ScheduleLink: React.FC<IValue> = ({
  value,
  addLink,
  hideLink,
  timezone,
}) => {
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [timezones, setTimezones] = useState([])
  const [selectedTimezone, setSelectedTimezone] = useState('')
  const [errors, setErrors] = useState<string>('')
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const queryId = params.get('id')

  const { t } = useTranslation()

  useEffect(() => {
    fetch('/admin/timezones.json')
      .then((response) => response.json())
      .then((data) => setTimezones(data))
      .catch((error) => console.error('Error loading timezones:', error))
  }, [])

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedTimezone(event.target.value)
  }

  const handleScheduleLink = () => {
    if (!value.title.trim() || !value.link.trim()) {
      setErrors(t('validation'))
      return
    }

    const data: any = {
      timezone: selectedTimezone,
      link: value.link,
      title: value.title,
    }
    if (startDate && endDate) {
      (data.addLink = new Date(startDate).toISOString()),
        (data.hideLink = new Date(endDate).toISOString())
    }
    queryId ? updateLink(data, queryId) : createLink(data)
  }
  return (
    <div className="mb-20">
      <p className="mt-5 font-semibold">{t('schedule')}</p>
      <p className="mb-5">{t('choose')}</p>
      <div className="mb-6 flex flex-col justify-between gap-6 lg:flex lg:flex-row lg:gap-4">
        <DatePickerComp
          startDate={startDate}
          handleChangeStartDate={(date) => date !== null && setStartDate(date)}
          endDate={endDate}
          handleChangeEndDate={(date) => date !== null && setEndDate(date)}
          addLink={addLink}
          hideLink={hideLink}
        />
      </div>
      <p className="mb-1 mt-5 font-semibold">{t('timezoneTitle')}</p>
      <p className='mb-3'>{t('timezone')}</p>
      <TimeZoneSelect
        handleChange={handleChange}
        data={timezones}
        value={selectedTimezone}
        initTimezone={timezone}
      />
      <p className="mt-2 text-sm text-red-600">{errors}</p>
      <Button
        text={t('schedule')}
        type="button"
        className="w-full text-white"
        onClick={handleScheduleLink}
      />
    </div>
  )
}
